import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Action } from '@ngrx/store';
import { setSharedData } from '../Authentication/authentication.actions';
import { CustomSnackbarComponent } from 'src/app/shared/custom-snackbar/custom-snackbar.component';
import { environment } from 'src/environments/environment.prod';
import { Clipboard } from '@angular/cdk/clipboard';
import { ContactQueriesService } from 'src/app/core/services/contact-queries/contact-queries.service';
import {
  getContactQueries,
  getContactQueriesFailure,
  getContactQueriesSuccess,
} from './contact-queries.action';

@Injectable()
export class ContactQueriesEffects {
  constructor(
    private actions$: Actions,
    private snackBar: MatSnackBar,
    private router: Router,
    private dialog: MatDialog,
    private contactQueriesService: ContactQueriesService,
    private clipboard: Clipboard
  ) {}

  getContactQueriesEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getContactQueries),
      switchMap((action) =>
        this.contactQueriesService.getContactQueries(action.data).pipe(
          mergeMap((res) => [
            getContactQueriesSuccess({ data: res }),
            setSharedData({ data: res }),
          ]),
          catchError((error) => {
            return of(getContactQueriesFailure({ error }));
          })
        )
      )
    );
  });
}
